export default {
  // 通用
  common: {
    loading: '加载中...',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    more: '更多',
    close: '关闭',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息'
  },

  // 导航菜单
  nav: {
    home: '首页',
    mainBusiness: '主营业务',
    newEnergy: '新能源',
    specialContainer: '特种箱散杂',
    europeLine: '欧洲线',
    southAmericaLine: '南美线',
    researchInstitute: '奥睿研究院',
    caseStudies: '案例研究',
    contactUs: '联系我们',
    aboutUs: '关于奥睿',
    contactInfo: '联系方式'
  },

  // 首页
  home: {
    title: '奥睿',
    subtitle: '',
    section3Title: '产业大脑将成为各城市、园区产业发展的标配',
    section4Title1: '核心资源整合能力',
    section4Title2: '多产业全球公开域数据积累',
    section4Title3: '亿级产业动态本体',
    section4SubTitle1: '背靠工信部直属事业单位中国电子信息产业发展研究院，具备强大的产业资源整合能力',
    section4Desc1: '支撑制造强国、网络强国建设，聚焦两化融合、智能制造、数字经济、军民融合等重点领域，逐步形成研究咨询、测试认证、科技服务、媒体会展、军工业务、产业金融等6大业务布局，服务20多个国家部委、400多个地方政府、5000多家行业企业。',
    section4SubTitle2: '完成覆盖9大战略性新兴产业、70+细分领域的全球公开域数据中心建设',
    section4Desc2: '全球 <span>10000+</span> 官方数据源 <span>100000+</span> 数据采集点',
    section4SubTitle3: '基石产业动态本体知识库，支撑产业数智升级',
    section5Title: '合作客户',
    section5SubTitle: '持续为用户创造独特价值',
    // 业务介绍
    business: {
      title: '核心业务',
      subtitle: '专业物流解决方案，让全球运输更简单高效',
        coreTag: '核心业务',
      carLogistics: {
        title: '汽车与新能源物流',
        description: '专为汽车行业量身定制的全球整合物流解决方案',
        features: [
          '整车运输安全保障',
          '新能源汽车专业处理',
          '全球物流网络覆盖',
          '实时追踪系统'
        ]
      },
      energyLogistics: {
        title: '新能源物流解决方案',
        description: '针对储能产品出口国外的全方位运输服务',
        features: [
          '储能产品专业包装',
          '多式联运方案',
          '清关服务支持',
          '海外配送网络'
        ]
      },
      solarLogistics: {
        title: '光伏组件运输',
        description: '太阳能板及相关配件全球运输服务',
        features: [
          '光伏组件专业保护',
          '全球安装点配送',
          '可再生能源支持',
          '环保运输方案'
        ]
      },
      containerLogistics: {
        title: '冷代干集装箱运输',
        description: '冷藏集装箱作为干货使用的优化运输方案',
        features: [
          '季节性舱位优化',
          '成本控制方案',
          'NOR专业操作',
          '温度监控系统'
        ]
      },
      steelLogistics: {
        title: '卷钢类产品物流',
        description: '钢材物流的专业处理与运输方案',
        features: [
          '卷钢专业固定',
          '重量平衡控制',
          '防滚动措施',
          '专业装卸设备'
        ]
      }
    }
  },

  // 新能源页面
  newEnergy: {
    bannerTitle: '新能源整车运输',
    bannerSubtitle: '安全、高效、合规的全球物流解决方案',
    bannerDescription: '为汽车制造商提供专业的新能源汽车全球运输服务，涵盖全链条运输模式、端到端物流服务、特种车辆处理',
    features: {
      title: '核心优势',
      item1: '专业团队',
      item2: '全球网络',
      item3: '合规保障',
      item4: '安全保障'
    },
    services: {
      title: '服务内容',
      item1: '整车运输',
      item2: '仓储管理',
      item3: '报关报检',
      item4: '保险服务'
    },
    // 案例页面
    case: {
      background: '项目背景',
      challenges: '核心挑战',
      solution: '专业解决方案',
      process: '关键操作流程',
      imageGallery: '案例图片展示',
      results: '项目成果',
      value: '专业价值体现'
    },
    // 生产大脑页面
    production: {
      coreBusiness: {
        title: '🚗 新能源整车运输的核心业务范围',
        subtitle: '专业物流服务，让新能源整车运输更安全高效'
      },
      keyChallenges: {
        title: '⚡ 新能源整车运输的关键挑战与专业应对',
        subtitle: '应对新能源整车运输的特殊要求，确保安全合规'
      },
      safetyGuarantees: {
        title: '🛡️ 安全与专业保障',
        subtitle: '全方位保障新能源整车运输的安全与质量'
      },
      greenPractices: {
        title: '🌱 绿色物流实践',
        subtitle: '响应新能源产业环保属性，打造绿色运输方案'
      },
      serviceProcess: {
        title: '📋 典型服务流程',
        subtitle: '专业的新能源整车出口物流服务全流程'
      }
    }
  },

  // 特种箱散杂页面
  specialContainer: {
    bannerTitle: '特种箱散杂运输',
    bannerSubtitle: '专业散杂运输解决方案，全球网络覆盖',
    bannerDescription: '我司拥有专业的散杂运输船队资源，包括5艘重吊船（组合吊重从200T到800T），共计20艘散杂船，主要分布在南美、印巴、中东、欧洲等航线。',
    features: {
      title: '核心优势',
      item1: '专业设备',
      item2: '丰富经验',
      item3: '全球网络',
      item4: '安全保障'
    },
    services: {
      title: '服务内容',
      item1: '特种箱运输',
      item2: '散杂货运输',
      item3: '项目物流',
      item4: '工程物流'
    },
    // 服务优势
    advantages: {
      title: '服务优势',
      subtitle: '专业、安全、高效的物流解决方案'
    },
    // 案例页面
    case: {
      challenge: '客户背景与挑战',
      solution: '我们的专业解决方案',
      imageGallery: '案例图片展示',
      results: '成果与价值',
      specifications: '技术参数',
      noSolutionData: '暂无解决方案数据',
      // 解决方案标题
      solutionTypeSelection: '集装箱类型选择',
      professionalLoading: '专业装载方案',
      transportationSafety: '运输安全保障',
      timeManagement: '时效管理',
      routePlanning: '路线规划',
      professionalSolution: '专业解决方案',
      professionalTransportation: '专业运输方案',
      // 成果标题
      safeEfficientDelivery: '安全高效交付',
      customerSatisfaction: '客户高度满意',
      professionalRecognition: '专业服务认可',
      successCase: '成功案例',
      excellentResults: '卓越成果',
      successfulDelivery: '成功交付',
      // 技术参数标签
      containerType: '集装箱类型',
      equipmentWeight: '设备重量',
      equipmentHeight: '设备高度',
      transportationTime: '运输时间',
      route: '运输路线'
    }
  },

  // 欧洲线页面
  europeLine: {
    title: '欧洲专线',
    subtitle: '连接中欧，畅通贸易，助力企业全球化发展',
    introduction: {
      title: '航线介绍',
      description: '专业欧洲专线物流服务，连接中欧贸易桥梁'
    },
    network: {
      title: '航线网络',
      description: '覆盖欧洲主要港口和城市，提供高效物流解决方案'
    },
    advantages: {
      title: '服务优势',
      description: '专业、高效、可靠的欧洲专线物流服务'
    },
    services: {
      title: '服务内容',
      description: '全方位物流解决方案，满足不同客户需求'
    }
  },

  // 南美线页面
  southAmericaLine: {
    title: '南美线',
    subtitle: '连接中南美，促进贸易，支持企业全球化',
    introduction: {
      title: '航线介绍',
      description: '专业南美专线物流服务，连接中国与南美贸易桥梁'
    },
    network: {
      title: '航线网络',
      description: '覆盖南美主要港口和城市，提供高效物流解决方案'
    },
    advantages: {
      title: '服务优势',
      description: '专业、高效、可靠的南美专线物流服务'
    },
    services: {
      title: '服务内容',
      description: '全方位物流解决方案，满足不同客户需求'
    }
  },

  // 案例研究
  caseStudies: {
    title: '案例研究',
    newEnergyCases: '新能源案例',
    specialContainerCases: '特种箱案例',
    industryReports: '行业报告'
  },

  // 联系我们
  contact: {
    title: '联系我们',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    wechat: '微信',
    workingHours: '工作时间',
    contactInfo: '联系信息',
    companyName: '公司名称',
    contactPerson: '联系人',
    message: '留言',
    send: '发送'
  },

  // 页脚
  footer: {
    copyright: '版权所有 ©2025 奥睿 . 保留所有权利 .',
    icp: '沪ICP备88888888号-1 沪公网安备 31088888888888号',
    links: '友情链接',
    contactUs: '联系我们',
    followUs: '关注我们'
  },

  // 错误页面
  error: {
    404: '页面未找到',
    500: '服务器错误',
    goHome: '返回首页'
  },

  // 表单验证
  validation: {
    required: '此字段为必填项',
    email: '请输入有效的邮箱地址',
    phone: '请输入有效的电话号码',
    minLength: '长度不能少于{min}个字符',
    maxLength: '长度不能超过{max}个字符'
  },

  // 公司介绍
  company: {
    introduction: {
      title: '公司介绍',
      subtitle: '专业物流服务，全球网络覆盖',
      name: '上海奥里里亚供应链管理有限公司',
      established: '成立于{year}年',
      description: '上海奥里里亚供应链管理有限公司创始于2013年，是一家可承接全国所有口岸及驳船码头进出口业务的综合物流服务商。总部位于上海市虹口区，并且在青岛/嘉兴/深圳/宁波设有分公司和办事处，熟悉全国主要港口及城市的进出口货物运输，包括海运、空运、海空联运、散杂货运输等业务，并为客户提供报关、商检、保险、仓储、拖车等一站式服务。',
      partners: {
        title: '合作伙伴',
        description: '我们汇聚全球顶级航运资源，包括CMA、MAERSK、MSC、COSCO、HAPAG-LLOYD、EVERGREEN、WHL、PIL、OOCL、ONE、YML、ZIM在内的前二十大船公司均建立了稳固的合作关系。这不仅构建了我们强大的服务网络，更确保了我们在任何航线上都能为您提供最优化的选择。从行业巨头马士基、MSC，到区域专家万海航运、以星航运，我们覆盖全梯队船公司的合作网络，赋予我们无与伦比的灵活性与定制能力，能为不同货型、不同航线需求的客户精准匹配最合适的船东资源。'
      },
      advantages: {
        title: '服务优势',
        experiencedTeam: '经验丰富的操作团队',
        experiencedTeamDesc: '具备多年物流行业经验的专业团队',
        capacityControl: '优势明显的控舱能力',
        capacityControlDesc: '与各大船公司保持良好合作关系',
        agentNetwork: '覆盖广泛的代理网络',
        agentNetworkDesc: '海内外代理网络覆盖全球主要港口',
        routeArrangement: '灵活的最优航线安排',
        routeArrangementDesc: '根据客户需求定制最优运输方案'
      },
      services: {
        title: '服务范围',
        transportation: '运输方式',
        transportationItems: ['海运', '空运', '陆运', '铁路', '多式联运', '散杂货运输'],
        supporting: '配套服务',
        supportingItems: ['报关', '商检', '保险', '仓储', '拖车'],
        extended: '延伸服务',
        extendedItems: ['租船订舱', '缮制单据', '船期预告', '运价查询', '代理保险'],
        network: '网络服务',
        networkItems: ['铁路运输', '公路中转', '海外网络', '内陆延伸服务']
      }
    }
  }
}
